import { BaseType } from '../base/base-type';

export class PaymentDirectionType extends BaseType {}
